import React, { useEffect, useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { clearHabitState, createHabit } from "../features/Habit/HabitSlice";
import { clearState } from "../features/User/UserSlice";
import CreateHabit from "../features/Habit/interfaces/CreateHabit";
import { RootState } from "../app/store";
import toast from "react-hot-toast";
import { useHistory } from "react-router";
import "../styles/components/add-habit.scss";
import add_habit from "../styles/utils/add_circle.svg";
import { Tooltip } from "@mui/material";
import CustomButton from "./CustomButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const AddHabit: React.FC = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const { isHabitError, habitError, isHabitsSuccess } = useSelector(
    (state: RootState) => state.habit
  );

  const [habitData, setHabitData] = useState<CreateHabit>({
    habit_name: "",
    habit_description: "",
  });

  const history = useHistory();

  const createHabitDispatch = async () => {
    const output = (await dispatch(createHabit(habitData))) as any;
    if (output?.type === "habit/createHabit/fulfilled") {
      handleClose();
      history.push("/empty");
      history.goBack();
    }
  };

  useEffect(() => {
    dispatch(clearHabitState());
    dispatch(clearState());
  }, []);

  useEffect(() => {
    if (isHabitError) {
      if (habitError[0] !== "Unauthorized") {
        toast.error(habitError[0]);
        clearHabitState();
      }
    }
  }, [habitError, isHabitError, isHabitsSuccess]);

  return (
    <div className="add-habit">
      <Tooltip title="Add new habit" placement="top">
        <div className="add-habit-button-area" onClick={handleOpen}>
          <img
            src={add_habit}
            alt="Add Habit Icon"
            style={{ width: "50px", height: "50px" }}
            className="add-habit--button"
          />
          <p>Add a new habit</p>
        </div>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="add-habit--modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
          className="box"
        >
          <TextField
            label="Habit name"
            required
            onChange={(e) => {
              setHabitData((prev) => ({ ...prev, habit_name: e.target.value }));
            }}
          />
          <TextField
            label="Habit description"
            onChange={(e) => {
              setHabitData((prev) => ({
                ...prev,
                habit_description: e.target.value,
              }));
            }}
          />
          <CustomButton
            onClick={() => createHabitDispatch()}
            displayText="Submit"
            className="create-habit-button"
            style={{
              backgroundColor: "white",
              border: "2px solid black",
              color: "black",
              boxShadow: "5px 5px 0",
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};
export default AddHabit;
